import React, { Component, Fragment } from 'react';
import { withStyles, CircularProgress } from '@material-ui/core'
import { translate } from 'react-i18next'
import { faFileUpload } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import axios from 'axios'
import clsx from 'clsx'

import { SimpleDialog, CustomToolTip } from '../../../../../common/components/UI'
import { updateSpinnerShow, updateSnackbar } from '../../actions'
import { currentHttpOptions } from '../../../../../common/utilities/utilitiesFunctions'
import { AsyncTaskType } from '../../../../Enums/AsyncTaskType';

const styles = theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        border: '1px solid #bdbdbd',
        borderRadius: 5,
    },
    disabledButton: {
        cursor: 'default !important',
        border: '1px solid #bdbdbd !important',
        color: '#bdbdbd !important'
    },
    tableColumnButton: {
        width: 34,
        minWidth: 34,
        border: '1px solid #0A54A2',
        cursor: 'pointer',
        height: 34,
        display: 'inline-block',
        marginTop: 1,
        marginLeft: 1,
        paddingLeft: 2,
        paddingTop: 5,
        borderRadius: 4,
        backgroundColor: 'transparent',
        color: '#0A54A2'
    },
    tableColumnButtonIcon: {
        marginLeft: 8,
    },
    tableColumnButtonLoading: {
        marginLeft: 4,
    },
})

class UploadExcel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileBlob: null,
            isOpen: false,
        };

        this.taskProgressionInterval = React.createRef(null);
    }

    handleUploadExcel = async () => {
        const { selectedWorkPlan, updateSpinnerShow, updateSnackbar, refreshWorkplan } = this.props
        const { fileBlob } = this.state
        updateSpinnerShow(true)
        this.setState({ isOpen: false });
        let formData = new FormData();
        formData.append('file', fileBlob);
        let config = currentHttpOptions()
        config.headers = {
            ...config.headers,
            'Content-Type': 'multipart/form-data'
        }

        try {
            await axios.post(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/UploadExcelTemplate/${selectedWorkPlan.workplanId}`,
                formData, config)
            // TODO : Manage error handling
            refreshWorkplan()
        } catch (ex) {
            let messages = this.customErrorHandling(ex.response)
            if (Array.isArray(messages)) {
                const url = window.URL.createObjectURL(new Blob(messages));
                let link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${selectedWorkPlan.name.replace(' ', '_')}_ShiftLinesUploadErrors.txt`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: `${messages.length} error(s) have been detected. Please review error report that has been downloaded to your browser's download folder.`,
                    openSnackbar: true,
                })
            }
            else {
                if (ex.response.status === 504 || ex.response.status === 499) {
                    updateSnackbar({
                        typeSnackbar: 'warning',
                        messageSnackbar: messages,
                        openSnackbar: true,
                        isNoAutoHideSnackbar: true
                    })
                } else {
                    updateSnackbar({
                        typeSnackbar: 'error',
                        messageSnackbar: messages,
                        openSnackbar: true,
                    })
                }

            }
        }
    }

    customErrorHandling = response => {
        if (response) {
            if (response.data.Message) {
                let messages = response.data.Message.split(/\n/)
                return messages.filter(message => message.trim().length > 0);
            }
            else if (response.status) {
                if (response.status === 500) {
                    return 'Internal server error. Please contact a system administrator.';
                }
                if (response.status === 504 || response.status === 499) {
                    return 'The process will take more time than expected, please come back in few minutes.';
                }
            }
        }
        else {
            return 'An error occured. Please contact a system administrator.'
        }
    }

    handleFileSelect = (e) => {
        this.setState({
            fileBlob: e.target.files[0],
        })
    }

    handleDialog = (isOpen) => {
        this.setState({
            isOpen: isOpen
        })
    }

    handleRefreshTaskProgression = (selectedWorkPlan, refreshWorkplan) => {
        axios.get(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/Workplan/${selectedWorkPlan.workplanId}/GetTaskProgression/${AsyncTaskType.ImportWorkplanShiftLineExcel}`, currentHttpOptions())
            .then((result) => {
                if (result.data.isCompleted) {
                    refreshWorkplan();
                }
            })
            .catch((err) => {
                // TODO Unsure what to do for now
            });
    }

    componentDidUpdate() {
        const { isImportingExcelAsync, selectedWorkPlan, refreshWorkplan } = this.props
        if (isImportingExcelAsync && this.taskProgressionInterval.current === null) {
            this.taskProgressionInterval.current = setInterval(() => {
                this.handleRefreshTaskProgression(selectedWorkPlan, refreshWorkplan);
            }, 5000);
        }
        else if (!isImportingExcelAsync && this.taskProgressionInterval.current !== null) {
            clearInterval(this.taskProgressionInterval.current);
            this.taskProgressionInterval.current = null;
        }
    }

    componentWillUnmount() {
        const { isImportingExcelAsync } = this.props
        if (isImportingExcelAsync && this.taskProgressionInterval.current !== null) {
            clearInterval(this.taskProgressionInterval.current);
            this.taskProgressionInterval.current = null;
        }
    }

    render() {
        const { t, classes, disableToolbar, isImportingExcelAsync } = this.props
        const { isOpen, fileBlob } = this.state
        return (
            <Fragment>
                <CustomToolTip enterDelay={500} placement="right-start" leaveDelay={500} titletext={t('workPlanView.table.uploadExcel')}
                    jsx={
                        <div
                            className={clsx(classes.tableColumnButton, disableToolbar && classes.disabledButton)}
                            onClick={() => !disableToolbar && !isImportingExcelAsync && this.handleDialog(true)}
                        >
                            {
                                isImportingExcelAsync
                                    ? <CircularProgress size={20} className={classes.tableColumnButtonLoading} />
                                    : <FontAwesomeIcon className={classes.tableColumnButtonIcon} icon={faFileUpload} />
                            }
                        </div>
                    }
                />
                <SimpleDialog
                    open={isOpen}
                    title={'Upload Shiftlines Excel file'}
                    acceptText={'Submit'}
                    rejectText={'Cancel'}
                    submit={this.handleUploadExcel}
                    cancel={() => this.setState({ isOpen: false, fileBlob: null })}
                    disabledSubmit={!fileBlob}
                    disabledButton={isImportingExcelAsync}
                >
                    <div className={classes.root}>
                        <input
                            accept=".xlsx"
                            className={classes.input}
                            id="contained-button-file"
                            type="file"
                            onChange={this.handleFileSelect}
                        />
                    </div>
                </SimpleDialog>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedWorkPlan: state.selectedWorkPlan
    }
}

const mapDispatchToProps = {
    updateSpinnerShow,
    updateSnackbar
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(translate('workplanManager')(UploadExcel)));